import * as v from "valibot";
import { SEED_REGEX } from "./constants";

export const PlayerNameSchema = v.pipe(
  v.string(),
  v.trim(),
  v.minLength(1, "name required"),
  v.maxLength(22, "name too long"),
);

export const RunSubmissionSchema = v.object({
  playerName:     PlayerNameSchema,
  score:          v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(1_000_000)),
  durationMs:     v.pipe(v.number(), v.integer(), v.minValue(1000), v.maxValue(86_400_000)),
  itemsCollected: v.pipe(v.number(), v.integer(), v.minValue(0), v.maxValue(10_000)),
  seed:           v.pipe(v.string(), v.regex(SEED_REGEX, "invalid seed")),
});

export type RunSubmission = v.InferOutput<typeof RunSubmissionSchema>;
